import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/Blog.css';
import '../../CSS/App.css';

const HomeNASBlog = () => {
  return (
    <div className="blog-container">
      <Link to="/blog" className="blog-back-link">← Back to Blog</Link>

      <p className="blog-post-title">Home NAS Solution</p>
      <p className="blog-meta">Docker · Nginx · Ubuntu Server · Self-Hosted</p>

      <div className="blog-body">
        <p>
          I didn't really want to pay every month for cloud storage when I already had a server sitting in my
          house. So instead I decided to make my own version of something like Google Drive that runs
          completely on my own hardware.
        </p>

        <h2>The Setup</h2>
        <p>
          The main part of it is File Browser, which is basically a lightweight file manager that you can
          access through a web browser. I run it inside a Docker container on my Ubuntu server and use Nginx
          as a reverse proxy in front of it.
        </p>
        <p>
          This was also one of the things that made me really appreciate Docker. Once I got the compose file
          working, managing the service became way easier than installing everything directly onto the server.
          Looking back I honestly wish I had containerized everything from the beginning.
        </p>

        <h2>Actually Accessing It</h2>
        <p>
          The harder part was figuring out how to access my files when I wasn't home without just exposing
          everything on my network to the internet.
        </p>
        <p>
          I set up authentication through Nginx and only forward the ports that I actually need. It's
          definitely not some enterprise storage solution, but it's my personal server and it works for what I
          need.
        </p>
        <p>
          I also have backups going to an external drive because having my entire storage system depend on one
          old computer with one drive is probably not the greatest idea. I learned pretty quickly that
          self-hosting something also means you're the person responsible when it breaks.
        </p>

        <h2>Was It Worth It?</h2>
        <p>
          For me, yeah.
        </p>
        <p>
          I don't have to pay a subscription, I don't really have an artificial storage limit besides however
          much storage I physically put into the server, local transfers are fast, and most importantly I
          control everything.
        </p>
        <p>
          Obviously that control comes with responsibility. If Google Drive goes down, that's Google's problem.
          If my server goes down, that's my problem. But honestly I kind of like that part too because fixing
          those problems is where I've learned a lot of what I know about servers.
        </p>
      </div>
    </div>
  );
};

export default HomeNASBlog;
